import {
  ORDER_COM_FAIL,
  ORDER_COM_REQUEST,
  ORDER_COM_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
} from '../constants/orderConstants';

export const detailsOrder =
  (orderId, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: ORDER_DETAILS_REQUEST, payload: orderId });
    try {
      const { data } = await axiosInstance.get(`/orders/${orderId}`);
      dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response?.data?.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: ORDER_DETAILS_FAIL, payload: message });
    }
    localStorage.setItem(
      'orderDetails',
      JSON.stringify(getState().orderDetails),
    );
  };

export const comOrder = (orderId, com, axiosInstance) => async (dispatch) => {
  dispatch({ type: ORDER_COM_REQUEST, payload: { orderId, com } });
  try {
    const { data } = await axiosInstance.put(`/orders/${orderId}/commentaire`, {
      commentaire: com,
    });
    localStorage.setItem('rating', true);
    dispatch({ type: ORDER_COM_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
    const message =
      error.response?.data?.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: ORDER_COM_FAIL, payload: message });
  }
};
